import React from 'react'
import { useNavigate, useLocation, Outlet } from 'react-router-dom'

import { useAuth } from '@/components/Auth'
import { checkRouterAuth } from './RouteAuth'
import { useEffect } from 'react'
// import { logInfo } from '@/common/logger/log'

// 路由守卫
export const RouterBeforeEach = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { isAuthenticated } = useAuth()

    useEffect(() => {
        const router = checkRouterAuth(location.pathname)
        // logInfo('page_show', {
        //     action: 'page_show',
        //     desc: '页面跳转',
        //     href: router.path,
        // })

        if (router && router.auth && !isAuthenticated) {
            navigate('/login', { replace: true, state: { from: location.pathname } })
        }
        // eslint-disable-next-line
    }, [isAuthenticated])
    return isAuthenticated ? <Outlet /> : null
}